import React from "react";

import * as UI from "./ui";
import { isPresent } from "../../lib/presence";

const Field = ({id, label, value, type, required, onChange, weight, errors, touched }) => {
  const [isBlurred, setIsBlurred] = React.useState(false);
  const showErrors = isBlurred || touched;

  const handleChange = (e) => {
    onChange(e);
  }

  return (
    <UI.FieldLayout weight={weight}>
      <UI.FieldBody>
        <UI.Input name={id} id={id} value={value} onChange={handleChange} onBlur={() => setIsBlurred(true)} $invalid={showErrors && isPresent(errors)} required={required} type={type} />
        <UI.Label htmlFor={id} empty={!value}>{label}</UI.Label>
        {isPresent(errors) && showErrors && (
          <UI.Errors>
            {errors}
          </UI.Errors>
        )}
      </UI.FieldBody>
    </UI.FieldLayout>
  );
}

export default Field;

